import React, { useState } from "react";
import { Dropdown, Button } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { useTour } from "../../contexts/TourContext";
import { useLocation } from "react-router-dom";
import SendEmailForm from "./SendEmailFrom";

function HelpMenu({ user }) {
  const { startTour, resetTours } = useTour();
  const location = useLocation();
  const [showContactModal, setShowContactModal] = useState(false);

  const handleStartTour = () => {
    if (location.pathname === "/dashboard") {
      startTour("dashboard");
    } else if (location.pathname === "/runbook") {
      startTour("runbooks");
    } else if (location.pathname === "/scheduler") {
      startTour("schedulers");
    } else if (location.pathname === "/variable") {
      startTour("variables");
    } else if (location.pathname === "/runbook/workflow") {
      startTour("workflow");
    } else if (location.pathname === "/permissions") {
      startTour("permissions");
    }
  };

  const handleResetTours = () => {
    resetTours();
    alert("All tours have been reset. You can now view them again!");
  };

  // Determine if a tour is available for the current page
  const isTourAvailable =
    location.pathname === "/dashboard" ||
    location.pathname === "/runbook" ||
    location.pathname === "/scheduler" ||
    location.pathname === "/variable" ||
    location.pathname === "/runbook/workflow" ||
    location.pathname === "/permissions";

  const supportEmail =
    import.meta.env.VITE_SUPPORT_EMAIL || "supportservices@armanino.com";

  const emailDetails = user ? {
    fromMail: user.email,
    fromName: user.firstName + " " + user.lastName,
    toMail: supportEmail,
    subject: `CloudSync Support - ${user?.clientName !== "" ? user.clientName : "SuperUser"}`,
    body: "",
  } : null;

  return (
    <>
      <Dropdown align="end">
        <Dropdown.Toggle
          variant="link"
          id="help-dropdown"
          className="text-decoration-none"
          style={{ color: "inherit" }}
        >
          <FaQuestionCircle size={20} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Header>Help & Tours</Dropdown.Header>
          {isTourAvailable ? (
            <Dropdown.Item onClick={handleStartTour}>
              Start Tour for This Page
            </Dropdown.Item>
          ) : (
            <Dropdown.Item disabled>
              No tour available for this page
            </Dropdown.Item>
          )}
          <Dropdown.Divider />
          <Dropdown.Item onClick={handleResetTours}>
            Reset All Tours
          </Dropdown.Item>
          {user && (
            <>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => setShowContactModal(true)}>
                <FiMail className="me-2" />
                Contact Support
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {showContactModal && user && emailDetails && (
        <SendEmailForm
          show={showContactModal}
          onHide={() => setShowContactModal(false)}
          emailDetails={emailDetails}
          user={user}
        />
      )}
    </>
  );
}

export default HelpMenu;